import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { MaterialMatcher } from '../material-matcher'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { ElderLabelInputComponent } from '@elderbyte/ngx-starter'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-material-matcher-detail',
  templateUrl: './material-matcher-detail.component.html',
  styleUrls: ['./material-matcher-detail.component.scss'],
  imports: [ElderLabelInputComponent, AsyncPipe, ElderTranslatePipe],
})
export class MaterialMatcherDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly _matcher$ = new BehaviorSubject<MaterialMatcher>(null)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set matcher(matcher: MaterialMatcher) {
    this._matcher$.next(matcher)
  }

  public get matcher$(): Observable<MaterialMatcher> {
    return this._matcher$.asObservable()
  }
}
